import {VIEW_TYPE} from "../../../../../enums/ViewType";
import AttendanceDayTable from "./AttendanceDayTable";
import {ATTENDANCE_MODES, MULTIDAYS_MODES} from "../../../Dining/Manage/Models/Model";
import AttendancePeriodTable from "./AttendancePeriodTable";
import AttendanceCurrentMap from "./AttendanceCurrentMap";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const AttendanceTable = ({
    setBodyForExport,
    searchElement,
    setSearchElement,
    option,
    selectedOption,
    setSimpleSearch,
    setSearch,
    contractorId,
    supplierId,
    search,
    setSendSimpleSearch,
    searchClean,
    setCriteria,
    setSelectedOption,
    setFinalArray,
    finalArray,
    view,
    setView,
    render,
    setRender,
    color,
    activeStep,
    modified,
    setModified,
    handleView
}) => {
    return (
        <>
            {view === VIEW_TYPE.LIST.name && (
                <>
                    {(selectedOption === ATTENDANCE_MODES.daily || search) && (
                        <AttendanceDayTable
                            selectedOption={selectedOption}
                            searchElement={searchElement}
                            search={search}
                            option={option}
                            setSimpleSearch={setSimpleSearch}
                            setSearch={setSearch}
                            finalArray={finalArray}
                            setSearchElement={setSearchElement}
                            setBodyForExport={setBodyForExport}
                            searchClean={searchClean}
                            contractorId={contractorId}
                            supplierId={supplierId}
                            setSendSimpleSearch={setSendSimpleSearch}
                            setSelectedOption={setSelectedOption}
                            view={view}
                            setView={setView}
                            color={color}
                            setCriteria={setCriteria}
                            modified={modified}
                            setModified={setModified}
                            handleView={handleView}
                        />
                    )}
                    {!search && MULTIDAYS_MODES.includes(selectedOption) && (
                        <AttendancePeriodTable
                            selectedOption={selectedOption}
                            searchElement={searchElement}
                            search={search}
                            option={option}
                            setSimpleSearch={setSimpleSearch}
                            setSearch={setSearch}
                            setFinalArray={setFinalArray}
                            finalArray={finalArray}
                            setSearchElement={setSearchElement}
                            setBodyForExport={setBodyForExport}
                            searchClean={searchClean}
                            contractorId={contractorId}
                            supplierId={supplierId}
                            setSendSimpleSearch={setSendSimpleSearch}
                            setSelectedOption={setSelectedOption}
                            view={view}
                            setView={setView}
                            render={render}
                            setRender={setRender}
                            color={color}
                            activeStep={activeStep}
                            modified={modified}
                            setModified={setModified}
                            handleView={handleView}
                        />
                    )}
                </>
            )}
            {view === VIEW_TYPE.GRID.name && (
                <AttendanceCurrentMap
                    view={view}
                    setView={setView}
                    option={option}
                    handleView={handleView}
                />
            )}
        </>
    );
}

export default AttendanceTable
